import { WeekDayEnum } from "../typings/enums/clinic";

export default class CalendarUtils {
  public static getViewTypeByViewImpl = (type: string): string => {
    return type?.replace("resourceTimeline", "");
  };
}
